import { FC, PropsWithChildren } from 'react';

import { clsx } from 'clsx';

import { CloseIcon } from '@shared/ui/CloseIcon';
import { HStack } from '@shared/ui/Stack';

import cls from './AttentionPlate.module.scss';

type AttentionPlateProps = { open: boolean; toggleOpen: () => void; className?: string } & PropsWithChildren;

export const AttentionPlate: FC<AttentionPlateProps> = ({ children, open, toggleOpen, className }) => {
  return (
    open && (
      <HStack className={clsx(cls.plate, className)}>
        <div>{children}</div>
        {
          <CloseIcon
            color={'#fafafa'}
            onClick={toggleOpen}
          />
        }
      </HStack>
    )
  );
};
